import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AlertController,ToastController,NavController, PickerController,ActionSheetController,ModalController, IonRouterOutlet } from '@ionic/angular';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import { GlobalVars } from '../../../providers/globalVars';
import { SelectchitemPage } from '../../support/selectchitem/selectchitem.page';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-adddiscount',
  templateUrl: './adddiscount.page.html',
  styleUrls: ['./adddiscount.page.scss'],
})
export class AdddiscountPage implements OnInit {
  placeitems:any[] = [];
  myitems:any[] = [];
  title:any;
  subtitle:any;
  ptype:any;
  uid:any;
  id:any = '';
  discountorder:any = 0;
  startdate: any;
  enddate: any;
  starttime: any;
  endtime: any;
  day: any;
  bgcolor: any = '';
  badgecolor: any = '';
  loclancode: any;
  admin:boolean = false;
  periodstr:any;
  url:any;
  selectedtitle:any;
  img:any;
  imgthumb:any;

  itemid:any;
  discount: any = [];
  weekstr = ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'];

  toedit:boolean = false;

  startdiff:any;
  enddiff:any;

  loc:any;
  error_loclan:boolean = false;

  constructor(public afDB: AngularFireDatabase,public gv: GlobalVars,public navCtrl:NavController,
    public pickerCtrl:PickerController, public actionsheetCtrl:ActionSheetController, public modalCtrl:ModalController,
    public afAuth: AngularFireAuth, public alertCtrl: AlertController,private toastCtrl: ToastController
    , private outlet: IonRouterOutlet, private route: ActivatedRoute) {
      this.loc = gv.getLoc();
      this.loclancode = gv.getLoc() + '_' + gv.getLan();
      if(this.route.snapshot.paramMap.get('id')){
        this.itemid = this.route.snapshot.paramMap.get('id'); //discount item의 id
        this.toedit = true;
      }
     }

  ngOnInit() {
    if( !this.gv.getLoc() || !this.gv.getLan() ) this.error_loclan = true;
    this.uid = firebase.auth().currentUser.uid;
    let today = new Date();
    let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
    this.afDB.database.ref('/systemlog/' + (this.uid?this.uid:'unregister') + '/event/' + todaystr + '/evententer').transaction(view=>{
      return (view || 0) + 1;
    })
    this.getdiscount();
  }

  getdiscount() {
    if( this.itemid ) {
      // this.afDB.database.ref('/discount').orderByChild('id').equalTo(this.itemid).once('value').then(list=>{
      //   if( list ) {
      //     let no = 0;
      //     list.forEach(l=>{
      //       if(no == 0){
      //         no++;
      //         let _ = l.val();

      //         _.title? this.title = _.title: null;
      //         _.subtitle? this.subtitle = _.subtitle: null;
      //         _.id? this.id = _.id:null;
      //         _.imgthumb? this.imgthumb = _.imgthumb: null;

      //         _.ptype? this.ptype = _.ptype: null;
      //         _.startdate? this.startdate = _.startdate: null;
      //         _.enddate? this.enddate = _.enddate: null;
      //         _.starttime? this.starttime = _.starttime: null;
      //         _.endtime? this.endtime = _.endtime: null;
      //         _.day? this.day = _.day: null;
              
      //         if(this.ptype == 'weekly')
      //           this.setweekperiodstr(this.day)
      //         else if(this.ptype == 'time')
      //           this.settimeperiodstr(this.starttime,this.endtime)
      //         else if(this.ptype == 'zday')
      //           this.setdayperiodstr(this.startdate,this.enddate)
      //       }
      //     })
      //   }
      // });
      this.afDB.database.ref('/discount/' + this.itemid).once('value').then(discount=>{
        if( discount.val() ) {
          let _ = discount.val();
          _.title? this.title = _.title: null;
          _.subtitle? this.subtitle = _.subtitle: null;
          if(_.id) {
            this.id = _.id;
            this.afDB.database.ref('/list/' + _.id).once('value').then(item=>{
              if( item.val() ) {
                let _ = item.val();
                console.log(_);
                _.title? this.selectedtitle = _.title: null;
              }
            });
          };
          _.img? this.img = _.img: null;
          _.imgthumb? this.imgthumb = _.imgthumb: null;

          _.ptype? this.ptype = _.ptype: null;
          _.startdate? this.startdate = _.startdate: null;
          _.enddate? this.enddate = _.enddate: null;
          _.starttime? this.starttime = _.starttime: null;
          _.endtime? this.endtime = _.endtime: null;
          _.day? this.day = _.day: null;
          
          if(this.ptype == 'weekly')
            this.setweekperiodstr(this.day)
          else if(this.ptype == 'time')
            this.settimeperiodstr(this.starttime,this.endtime)
          else if(this.ptype == 'zday')
            this.setdayperiodstr(this.startdate,this.enddate)
        }
      });
      
    }
  }

  async showtypeselection(){
    const actionSheet = await this.actionsheetCtrl.create({
      header: '기간 유형을 알려주세요.',
      buttons: [{
        text: '시작일~종료일',
        handler: () => {
          this.showperiod();
        }
      }, {
        text: '매주 특정 요일',
        handler: () => {
          this.showdayselect();
        }
      }, {
        text: '매일 특정 시간',
        handler: () => {
          this.showtimeselect();
        }
      }]
    })
    await actionSheet.present();
  }

  editconfirm(){
    if( this.toedit ) {

      // this.afDB.database.ref('/discount/').once('value').then(list=>{
      //   if( list.val() ) {
      //     let _ = list.val();
      //     let _disc = Object.keys(_).filter((disc)=>{
      //       if( _[disc].id == this.itemid ) return {disc: _[disc]}
      //     });
      //     if( _disc[0] ) {
      //       if(this.title && this.subtitle && this.ptype) {
      //         this.afDB.database.ref('/discount/' + _disc[0]).update({
      //           uid:this.uid, 
      //           id:this.id, 
      //           imgthumb: this.imgthumb?this.imgthumb:null, 
      //           loclancode:this.loclancode, 
      //           title:this.title, 
      //           subtitle:this.subtitle, 
      //           ptype:this.ptype,
      //           startdate:this.startdate, 
      //           enddate:this.enddate, 
      //           discountorder:this.discountorder, 
      //           bgcolor:this.bgcolor, 
      //           badgecolor:this.badgecolor
      //         });
      //         this.presentToast('bottom', '할인정보를 수정 하였습니다.', 3000);
      //         this.navCtrl.pop();
      //       } else {
      //         this.presentToast('bottom', '항목을 모두 기입해주세요.', 3000);
      //       }
      //     }
      //   }
      // });
      this.afDB.database.ref('/discount/' + this.itemid).once('value').then(item=>{
        if( item.val() ) {
          if(this.title && this.subtitle && this.ptype) {
            this.afDB.database.ref('/discount/' + this.itemid).update({
              uid: item.val().uid, 
              id:this.id, 
              img: this.img?this.img:null, 
              imgthumb: this.imgthumb?this.imgthumb:null, 
              loclancode:this.loclancode, 
              title:this.title, 
              subtitle:this.subtitle, 
              ptype: this.ptype,
              startdate: this.startdate?this.startdate:null, 
              enddate:this.enddate?this.enddate:null, 
              discountorder:this.discountorder?this.discountorder:null, 
              bgcolor:this.bgcolor?this.bgcolor:null, 
              badgecolor:this.badgecolor?this.badgecolor:null
            });
            this.presentToast('bottom', '할인정보를 수정 하였습니다.', 3000);
            this.navCtrl.pop();
          } else {
            this.presentToast('bottom', '항목을 모두 기입해주세요.', 3000);
          }
        }
      });

    }
  }
  submit(){
    if( this.error_loclan ) {
      this.presentToast('bottom', '지역값 또는 언어값 오류. 페이지를 다시 들어와 주세요.', 3000);
      return false;
    }
    if(this.title && this.subtitle && this.ptype)
    {
      let today = new Date();
      let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
            
        if(this.ptype == 'zday' && this.startdate && this.enddate)
        {
            this.afDB.database.ref('/discount').push({
                uid:this.uid, id:this.id, 
                img: this.img ? this.img : null,
                imgthumb:this.imgthumb?this.imgthumb:null, 
                loclancode:this.loclancode, title:this.title, subtitle:this.subtitle, ptype:this.ptype,
                startdate:this.startdate, enddate:this.enddate, 
                discountorder:this.discountorder, bgcolor:this.bgcolor, badgecolor:this.badgecolor
            });
            this.presentToast('bottom', '할인정보를 추가하였습니다.', 3000);
            this.afDB.database.ref('/systemlog/' + (this.uid?this.uid:'unregister') + '/event/' + todaystr + '/eventwrite').transaction(view=>{
              return (view || 0) + 1;
            })
            this.navCtrl.pop();
        }
        else if(this.ptype == 'weekly' && this.day)
        {
            this.afDB.database.ref('/discount').push({
                uid:this.uid, id:this.id, 
                img: this.img ? this.img : null,
                imgthumb:this.imgthumb?this.imgthumb:null, loclancode:this.loclancode, title:this.title, subtitle:this.subtitle, ptype:this.ptype,
                day:this.day, discountorder:this.discountorder, bgcolor:this.bgcolor, badgecolor:this.badgecolor
            });
            this.presentToast('bottom', '할인정보를 추가하였습니다.', 3000);
            this.afDB.database.ref('/systemlog/' + (this.uid?this.uid:'unregister') + '/event/' + todaystr + '/eventwrite').transaction(view=>{
              return (view || 0) + 1;
            })
            this.navCtrl.pop();
        }
        else if(this.ptype == 'time' && this.starttime && this.endtime)
        {
            this.afDB.database.ref('/discount').push({
                uid:this.uid, id:this.id, 
                img: this.img ? this.img : null,
                imgthumb:this.imgthumb?this.imgthumb:null, loclancode:this.loclancode, title:this.title, subtitle:this.subtitle, ptype:this.ptype,
                starttime:this.starttime, endtime:this.endtime, discountorder:this.discountorder, bgcolor:this.bgcolor, badgecolor:this.badgecolor
            });
            this.presentToast('bottom', '할인정보를 추가하였습니다.', 3000);
            this.afDB.database.ref('/systemlog/' + (this.uid?this.uid:'unregister') + '/event/' + todaystr + '/eventwrite').transaction(view=>{
              return (view || 0) + 1;
            })
            this.navCtrl.pop();
        }
        else
        this.presentToast('bottom', '항목을 모두 기입해주세요.', 3000);
    }
    else
        this.presentToast('bottom', '항목을 모두 기입해주세요.', 3000);

  }

  close(){
    this.navCtrl.pop();
  }

  async presentToast(position: string,message: string ,duration: number) {
    let toast = await this.toastCtrl.create({
      message: message,
      position: 'bottom',
      duration: duration
    });
    toast.present();
  }

  setweekperiodstr(data)
  {
      this.periodstr = data.map(d=>this.weekstr[d])
  }

  settimeperiodstr(start,end)
  {
      this.periodstr = start + ' ~ ' + end;
  }

  setdayperiodstr(start,end)
  {
    this.startdiff = Math.ceil((new Date().getTime() - new Date(start).getTime() - (1000*60*60*24))/(1000*60*60*24));
    this.enddiff = Math.ceil((new Date(end).getTime() - new Date().getTime())/(1000*60*60*24));
    this.periodstr = start + ' ~ ' + end;          
  }


  async showdayselect(){
    const alert = await this.alertCtrl.create({
      subHeader: '다중선택 가능',
      inputs:[
        { type: 'checkbox', value:1, label: this.weekstr[1]},
        { type: 'checkbox', value:2, label: this.weekstr[2]},
        { type: 'checkbox', value:3, label: this.weekstr[3]},
        { type: 'checkbox', value:4, label: this.weekstr[4]},
        { type: 'checkbox', value:5, label: this.weekstr[5]},
        { type: 'checkbox', value:6, label: this.weekstr[6]},
        { type: 'checkbox', value:0, label: this.weekstr[0]},
      ],
      buttons: [
      {
        text: '완료',
        handler: (data) => {
          this.day = data;
          this.ptype = 'weekly';
          this.periodstr = data.map(d=>this.weekstr[d])
          /*if(data)
          {
            data.forEach(w=>{
              console.log(w + ':' + weekstr[w])
            })
          }*/
        }
      }
    ]});
    await alert.present();
  }

  showtimeselect(){
    let columnset = this.gettimepickerarray();
    this.timestart(columnset);
  }

  async timestart(columnset){
    const picker = await this.pickerCtrl.create({
      columns: columnset,
      buttons: [
      {
        text: '다음',
        handler: (data) => {
          this.timeend(data);
        }
      }
    ]});
    await picker.present();
  }
  async timeend(startdata){
    let columnset = this.gettimepickerarray();
    const picker = await this.pickerCtrl.create({
      columns: columnset,
      buttons: [
        {
        text: '이전',
        handler: () => {
          this.timestart(this.gettimepickerarray());
        }},
      {
        text: '완료',
        handler: (data) => {
          this.starttime = startdata.time.value;
          this.endtime = data.time.value;
          this.ptype = 'time';
          this.periodstr = startdata.time.text + ' ~ ' + data.time.text;
        }
      }
    ]});
    await picker.present();
  }


  showperiod(){
    let columnset = this.getdatepickarray(45, false, null);
    this.periodstart(columnset);
  }

  async periodstart(columnset){
    const picker = await this.pickerCtrl.create({
      columns: columnset,
      buttons: [
      {
        text: '다음',
        handler: (data) => {
          this.periodend(data.date.value);
        }
      }
    ]});
    await picker.present();
  }
  async periodend(recdate){
    let startdate = this.convertkrdatetonormal(recdate);
    
    let columnset = this.getdatepickarray(60, false, null,startdate);
    const picker = await this.pickerCtrl.create({
      columns: columnset,
      buttons: [
        {
        text: '이전',
        handler: () => {
          this.periodstart(this.getdatepickarray(45, false, null));
        }},
      {
        text: '완료',
        handler: (data) => {
          this.startdate = startdate;
          this.enddate = this.convertkrdatetonormal(data.date.value);
          this.ptype = 'zday';
          this.startdiff = Math.ceil((new Date().getTime() - new Date(this.startdate).getTime() - (1000*60*60*24))/(1000*60*60*24));
          this.enddiff = Math.ceil((new Date(this.enddate).getTime() - new Date().getTime())/(1000*60*60*24));
          this.periodstr = recdate.split('년')[1] + ' ~ ' + (recdate.split('년')[0] != data.date.value.split('년')[0]? data.date.value:data.date.value.split('년')[1])          
        }
      }
    ]});
    await picker.present();
  }
  convertkrdatetonormal(krdate){
    let result, tempdate;
    if(krdate)
    {    
      tempdate = krdate.split('(')[0].replace('년','-').replace('월','-').replace('일','');
      result = tempdate.split('-')[0] + '-' + (tempdate.split('-')[1].length == 1? '0'+tempdate.split('-')[1]:tempdate.split('-')[1])
       + '-' + (tempdate.split('-')[2].length == 1? '0'+tempdate.split('-')[2]:tempdate.split('-')[2])
    }
    return result;
  }
 
  async showlink(){
    const modal = await this.modalCtrl.create({
      component: SelectchitemPage,
      cssClass: 'ph-custom-modal'
    });
    modal.onDidDismiss().then(rst=>{
      if(rst.data)
      {
      this.id = rst.data.itemid;
      this.img = rst.data.img;
      this.imgthumb = rst.data.imgthumb;
      this.selectedtitle = rst.data.itemtitle;
      this.subtitle = rst.data.itemtitle;
      }
    })
    return await modal.present();
  }
  
  
  gettimepickerarray(){
    var sltindex = [];
    var temparray = [];

    var timenow = new Date();
    var timearray = [];
    
    for(let i = 0 ; i < 12; i++)
    {
        timearray.push({text:'오전 ' + (i) + '시',value:(i<10?'0'+i:i)+':00'})
        timearray.push({text:'오전 ' + (i) + '시 반',value:(i<10?'0'+i:i)+':30'})
    }
     
    for(let i = 0 ; i < 12; i++)
    {
        if(i == 0)
          timearray.push({text:'오후 ' + '12시',value:'12:00'});
        else
          timearray.push({text:'오후 ' + (i) + '시',value:(i+12)+':00'})
        if(i == 0)
          timearray.push({text:'오후 ' + '12시 반',value:'12:30'});
        else if(i < 12)
          timearray.push({text:'오후 ' + (i) + '시 반',value:(i+12)+':30'})          
    }
    timearray.push({text:'오전 ' + '0시',value:'24:00'});
    
      temparray = [{name:'time',options:timearray, selectedIndex:24}];
      return temparray;
  }


  getdatepickarray(maxday,time, val, startdate?){
    var sltindex = [];
    var valsplit = '';
    if(val)
      valsplit = val.split(' ');
    var temparray = [];

    var timenow = new Date();
    var datearray = [];
    var ampm = [];
    var hour = [];
    var min = [];
    var dayarray = ['일','월','화','수','목','금','토'];
    if(!maxday)
        maxday = 31;
    for(let i = 0 ; i < maxday; i++)
    {
        var arraydate
        if(startdate)
          arraydate = new Date(new Date(startdate).getTime() + (1000*60*60*24*i))
        else 
          arraydate = new Date(timenow.getTime() + (1000*60*60*24*i))
        var arraystr = 
        (arraydate.getMonth()+1) + '월 ' +
        arraydate.getDate() + '일 (' +
        dayarray[arraydate.getDay()] + ')'; 
        var arrval = arraydate.getFullYear() +'년' + arraystr.replace(/ /g, '')
        datearray.push({text:arraystr, value:arrval});
        if(arrval == valsplit[0])
          sltindex[0] = i;
      }
    if(time)
    {
    ampm.push({text:'오전',value:'오전'})
    ampm.push({text:'오후',value:'오후'})

    if(valsplit[1] == '오후')
      sltindex[1] = 1;
    
    for(let i = 0 ; i < 12; i++)
    {
        hour.push({text:(i+1) + '시',value:(i+1) + '시'})
        if(valsplit[2] == (i+1) + '시')
          sltindex[2] = i;
    }
    for(let i = 0 ; i < 12; i++)
    {
        if(i < 2)
            min.push({text:'0' + (i*5) + '분',value:'0' + (i*5) + '분'})
        else
            min.push({text:(i*5) + '분',value:(i*5) + '분'})
        if(valsplit[3] == (i*5) + '분')
          sltindex[3] = i;
    }
    
    temparray = [
        {
            name: 'date',
            columnWidth:'50%',
            selectedIndex:sltindex[0]?sltindex[0]:0,
            options: datearray
        },
        {
            name: 'ampm',
            columnWidth:'16%',
            selectedIndex:sltindex[1]?sltindex[1]:0,
            options: ampm
        },{
            name: 'hour',
            selectedIndex:sltindex[2]?sltindex[2]:0,
            columnWidth:'17%',
            options: hour
        },{
            name: 'min',
            selectedIndex:sltindex[3]?sltindex[3]:0,
            columnWidth:'17%',
            options: min
        },
    ];
    }
    else
    {
      temparray = [
        {
            name: 'date',
            selectedIndex:sltindex[0]?sltindex[0]:0,
            options: datearray
        }]
    }
    return temparray;
  }
}
